<script setup lang="ts">
import {
	CREDIT_INPUT_LIMITS,
	formatBrl,
	formatPercent,
	formatPlainInput,
	useCreditSimulator
} from '~/composables/credit';

import CreditSimulatorAmountField from './CreditSimulatorAmountField.vue';
import CreditSimulatorSummary from './CreditSimulatorSummary.vue';

const simulator = useCreditSimulator();
const inputs = computed(() => simulator.state.value.inputs);
const result = simulator.consortium;

const summaryItems = computed(() => [
	{ label: 'Juros', value: 'Nenhum' },
	{
		label: 'Taxa de adm. total',
		value: formatPercent(result.value.adminFeePercent, 1)
	},
	{
		label: 'Lance para antecipar (referência de 30%)',
		value: formatBrl(result.value.referenceBid),
		isFullWidth: true
	}
]);
</script>

<template>
	<div class="flex flex-col gap-4.5">
		<CreditSimulatorAmountField
			label="Valor da carta de crédito"
			range-id="c-carta"
			text-id="c-carta-n"
			text-label="Valor da carta em reais"
			:amount-value="inputs.consortiumLetter"
			:range-value="inputs.consortiumLetter"
			v-bind="CREDIT_INPUT_LIMITS.consortiumLetter"
			@amount="simulator.setInput('consortiumLetter', $event)"
			@commit="simulator.commitInput('consortiumLetter')"
			@slide="simulator.setInput('consortiumLetter', $event)"
		/>
		<CreditSimulatorAmountField
			label="Prazo do grupo"
			range-id="c-prazo"
			text-id="c-prazo-n"
			text-label="Prazo do grupo em meses"
			unit="meses"
			:text-value="formatPlainInput(inputs.consortiumMonths)"
			:range-value="inputs.consortiumMonths"
			v-bind="CREDIT_INPUT_LIMITS.consortiumMonths"
			@type="simulator.typeInput('consortiumMonths', $event)"
			@commit="simulator.commitInput('consortiumMonths')"
			@slide="simulator.setInput('consortiumMonths', $event)"
		/>
		<CreditSimulatorSummary
			:headline="{
				label: 'Parcela mensal estimada',
				value: formatBrl(result.installment)
			}"
			:items="summaryItems"
		/>
		<div class="text-[12px] text-[#8A8A8A]">
			Taxa de administração média de 0,073% a.m. (Abac). Não inclui fundo de
			reserva, seguro e reajuste anual da carta.
		</div>
	</div>
</template>
